import Swiper from './swiper.min.js';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';

class SideCart extends HTMLElement {
  constructor() {
    super();
    this.cartRendered = false;
  }

  connectedCallback() {
    this.updateQuantity();
    this.removeTrigger();
    this.updateSubscription();
    this.cancelSubscription();
    this.upgradeToSubscription();
    this.recommendations();
    this.checkParams();
    this.mobileRecommendations()

    const self = this;
    document.querySelectorAll('.open-sidecart').forEach(function (el) {
      el.addEventListener('click', function () {
        self.openCart();
      });
    });

    document.querySelectorAll('.sidecart__close-cart').forEach(close => {
      close.addEventListener('click', () => {
        document.querySelector('.sidecart__wrapper').classList.add('!hidden');
        document.querySelectorAll('.open-sidecart').forEach(item => item.classList.remove('active'));
      });
    });
  }

  openCart() {
    document.querySelector('.sidecart__wrapper').classList.remove('!hidden');
    if (!this.cartRendered) {
      document.getElementById('sidecart-inner-mob').classList.add('opacity-0');
      document.getElementById('sidecart-inner-desktop').classList.add('opacity-0');
      this.renderCart();
      this.cartRendered = true;

      setTimeout(() => {
        this.cartRendered = false;
      }, 1000);
    }

    document.querySelectorAll('.open-sidecart').forEach(item => item.classList.add('active'));

    if (window.innerWidth < 1024) {
      document.querySelector('.drawer-toggle[data-handle="mobile-cart"]').click();
    }
  }

  renderCart() {
    const self = this;

    if (window.innerWidth >= 1024) {
      let itemsCount = document.querySelector('side-cart').dataset.count;

      fetch(window.Shopify.routes.root + "?sections=sidecart")
        .then(res => res.json())
        .then(data => {
          let html = document.createElement('div');
          html.innerHTML = data.sidecart;
          let updateItemsCount = html.querySelector('side-cart').dataset.count;

          document.querySelector('.cart-count').innerText = html.querySelector('side-cart').dataset.count;
          if (html.querySelector('side-cart').dataset.count > 0) {
            document.querySelector('.cart-count').classList.remove('hidden');
          } else {
            document.querySelector('.cart-count').classList.add('hidden');
          }

          if(html.querySelector('#cart-progress-line') && document.querySelector('#cart-progress-line')) {
            html.querySelector('#cart-progress-line').style.width = document.querySelector('#cart-progress-line').style.width;
          }

          document.getElementById('sidecart-inner').innerHTML = html.querySelector('#sidecart-inner').innerHTML;
          document.querySelector('.sidecart-items')?.classList.remove('opacity-80');
          
          if(html.querySelector('#cart-progress-line') && document.querySelector('#cart-progress-line')) {
            setTimeout(() => {
              document.querySelector('#cart-progress-line').style.width = html.querySelector('#cart-progress-line').dataset.progress + '%'
            }, 10);
          }

          document.querySelector('button.sidecart__close-cart').addEventListener('click', () => {
            document.querySelector('.sidecart__wrapper').classList.add('!hidden');
            document.querySelectorAll('.open-sidecart').forEach(item => item.classList.remove('active'));
          });

        })
        .catch(error => {
          console.error('Error rendering cart:', error);
        });
    } else {
      let itemsCount = document.querySelector('#mobile-cart').dataset.count;
      fetch(window.Shopify.routes.root + "?sections=header")
        .then(res => res.json())
        .then(data => {
          let html = document.createElement('div');
          html.innerHTML = data.header;
          let updateItemsCount = html.querySelector('#mobile-cart').dataset.count;

          document.querySelectorAll('.cart-count').forEach(item => item.innerText = html.querySelector('#mobile-cart').dataset.count);
          if (html.querySelector('#mobile-cart').dataset.count > 0) {
            document.querySelectorAll('.cart-count').forEach(item => item.classList.remove('hidden'));
          } else {
            document.querySelectorAll('.cart-count').forEach(item => item.classList.add('hidden'));
          }
          
          if(html.querySelector('#cart-progress-line-mob') && document.querySelector('#cart-progress-line-mob')) {
            html.querySelector('#cart-progress-line-mob').style.width = document.querySelector('#cart-progress-line-mob').style.width;
          }
          document.getElementById('sidecart-inner-mob').innerHTML = html.querySelector('#sidecart-inner-mob').innerHTML;
          document.querySelector('.sidecart__wrapper-mobile .sidecart-items')?.classList.remove('opacity-80');
          document.getElementById('sidecart-inner-mob').classList.remove('opacity-0');

          if(html.querySelector('#cart-progress-line-mob') && document.querySelector('#cart-progress-line-mob')) {
            setTimeout(() => {
              document.querySelector('#cart-progress-line-mob').style.width = html.querySelector('#cart-progress-line-mob').dataset.progress + '%'
            }, 10);          
          }
          self.mobileRecommendations();
        })
        .catch(error => {
          console.error('Error rendering mobile cart:', error);
        });
    }
  }

  updateQuantity() {
    const self = this;
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (target.classList.contains('quantity__button')) {
        const item = target.closest('.sidecart-item');
        item.classList.add('opacity-80');

        let input = target.closest('quantity-input').querySelector('input');
        let key = input.dataset.key;
        let value = parseInt(input.value);

        input.value = value;

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: value,
            sections: ['sidecart', 'header'],
          }),
        })
          .then(response => response.json())
          .then(data => {
            self.renderCart();
          })
          .catch(error => {
            console.error('Error changing product quantity:', error);
            item.classList.remove('opacity-80');
          });
      }
    });
  }

  removeTrigger() {
    const self = this;
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (target.classList.contains('sidecart__remove')) {
        const item = target.closest('.sidecart-item');
        item.classList.add('opacity-80');

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: target.dataset.id,
            quantity: 0,
            sections: ['sidecart', 'header'],
          }),
        })
          .then(response => response.json())
          .then(data => {
            self.renderCart();
          })
          .catch(error => {
            console.error('Error removing product from cart:', error);
            item.classList.remove('opacity-80');
          });
      }
    });
  }

  updateSubscription() {
    const self = this;
    document.addEventListener('change', function (e) {
      let target = e.target;

      if (target.classList.contains('subscription-select')) {
        const item = target.closest('.sidecart-item');
        item.classList.add('opacity-80');

        const key = target.dataset.key;
        const sellingPlan = target.value;

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            selling_plan: sellingPlan,
            sections: ['sidecart', 'header'],
          }),
        })
          .then(response => response.json())
          .then(data => {
            self.renderCart();
          })
          .catch(error => {
            console.error('Error updating subscription:', error);
            item.classList.remove('opacity-80');
          });
      }
    });
  }

  cancelSubscription() {
    const self = this;
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (target.classList.contains('sidecart__cancel-subscription')) {
        e.preventDefault();
        const item = target.closest('.sidecart-item');
        item.classList.add('opacity-80');

        const key = target.dataset.key;

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            selling_plan: null,
            sections: ['sidecart', 'header'],
          }),
        })
          .then(response => response.json())
          .then(data => {
            self.renderCart();
          })
          .catch(error => {
            console.error('Error cancelling subscription:', error);
            item.classList.remove('opacity-80');
          });
      }
    });
  }

  upgradeToSubscription() {
    const self = this;
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (target.classList.contains('sidecart__upgrade-subscription')) {
        const item = target.closest('.sidecart-item');
        item.classList.add('opacity-80');

        const key = target.dataset.key;
        const sellingPlan = target.dataset.sellingPlan;

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            selling_plan: sellingPlan,
            sections: ['sidecart', 'header'],
          }),
        })
          .then(response => response.json())
          .then(data => {
            self.renderCart();
          })
          .catch(error => {
            console.error('Error upgrading to subscription:', error);
            item.classList.remove('opacity-80');
          });
      }
    });
  }

  recommendations() {
    const self = this;
    document.addEventListener('click', function (e) {
      let target = e.target;

      if (target.classList.contains('cart-recommend-atc')) {
        const item = target.closest('.cart-recommend-item');
        item.classList.add('opacity-80');

         let formData = {
            items: [
              {
                id: target.dataset.key,
                quantity: 1,
              },
            ],
          }
      
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              let sidecart = document.querySelector('side-cart')
              sidecart?.openCart()
            })
            .catch((error) => {
              console.error('Error:', error)
            })
      }
    });
  }

  checkParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const cart = urlParams.get('cart');

    if (cart === 'open') {
      this.openCart();
    }
  }

  mobileRecommendations() {
    const swiper = new Swiper(document.querySelector('.mobile-recommendations'), {
        slidesPerView: 1.4,
        spaceBetween: 16,
        loop: true,
        modules: [ Pagination ],
        pagination: {
            el: document.querySelector('.recommendations-pagination'),
          },
        breakpoints: {
          500: {
            slidesPerView: 1.6
          },
          600: {
            slidesPerView: 2.2
          },

        }
    })
  }
}

customElements.define('side-cart', SideCart);